import {
  CART_ADD_SUCCESS,
  CART_REMOVE,
  CART_ADD_FAIL,
  UPDATE_FROM_SERVER,
} from "../actions/types";

const initialState = {
  loading: true,
  cart: localStorage.cart ? JSON.parse(localStorage.cart) : [],
};

export default function (state = initialState, action) {
  const { type, payload } = action;

  switch (type) {
    case CART_ADD_SUCCESS:
      !localStorage.cart && localStorage.setItem("cart", JSON.stringify([]));
      const cartArr = JSON.parse(localStorage.cart);
      if (JSON.parse(localStorage.cart).length > 0) {
        var a = true;
        if (a === true) {
          var matchFlag = false;

          cartArr.forEach((e) => {
            if (e.item._id === payload.item._id) {
              matchFlag = true;

              e.quantity = payload.quantity + e.quantity;
              console.log(e.quantity);
              a = false;
            }
          });
          if (!matchFlag) {
            cartArr.push(payload);
          }

          localStorage.setItem("cart", JSON.stringify(cartArr));

          return {
            ...state,
            cart: cartArr,
            loading: false,
          };
        }
      } else if (
        JSON.parse(localStorage.cart) ||
        JSON.parse(localStorage.cart).length === 0
      ) {
        const newArr = [payload];
        localStorage.setItem("cart", JSON.stringify(newArr));
        return {
          ...state,
          cart: newArr,
          loading: false,
        };
      }

    case CART_REMOVE:
      return {
        ...state,
        cart: payload,
        loading: false,
      };

    case CART_ADD_FAIL:
      return {
        ...state,
        cart: [],
        loading: false,
      };

    case UPDATE_FROM_SERVER:
      localStorage.setItem("cart", JSON.stringify(payload));

      return {
        ...state,
        cart: payload,
        loading: false,
      };

    default:
      return state;
  }
}
